import React from 'react'
import { useTranslation } from 'react-i18next'

import { Meal, UserNutritionalNeeds } from '@/api/types'
import { roundObjectValues } from '@/utils'
import { MACROS, SORTED_MEALS } from '../constants'
import './NutritionalNeeds.css'

type Props = {
  nutritionalNeeds?: UserNutritionalNeeds
  selectedMeals: Meal[]
}

export default function NutritionalNeeds({ nutritionalNeeds }: Props) {
  const { t } = useTranslation()
  const nutriNeeds = {
    ...nutritionalNeeds,
    mealsKcalNeed: roundObjectValues(nutritionalNeeds?.mealsKcalNeed || {}),
    nutrientNeeds: roundObjectValues(nutritionalNeeds?.nutrientNeeds || { KCAL: 0 }),
  }
  const dailyEnergy = nutriNeeds.nutrientNeeds.KCAL || 0

  function getDailyEnergyPercentage(meal: string) {
    let percent = Math.round((nutriNeeds.mealsKcalNeed[meal] / dailyEnergy) * 100)

    if (isNaN(percent)) {
      return 0
    }

    return percent
  }

  return (
    <div className="nutritionalNeeds">
      <div
        className="requirementGroup energy"
        style={{ background: '#fee18e', borderRadius: '12px', padding: '20px' }}>
        <div className="title">{t('nutritionalNeeds.dailyRequirements')}</div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderTop: '2px solid',
            borderBottom: '2px solid',
          }}>
          <div className="energy-big">Energy</div>
          <div className="energy-value">{dailyEnergy}</div>
        </div>

        {MACROS.map((macro) => (
          <div
            key={macro}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              borderBottom: '1px solid',
            }}>
            <div>{t(`nutrient.${macro}` as any)}</div>
            <div>{nutriNeeds.nutrientNeeds[macro]}g</div>
          </div>
        ))}
      </div>
      <div className="mealDistribution">
        <h4>{t('nutritionalNeeds.mealDistribution')}</h4>
        <div className="mealOfDayRowHeader mealOfDayRow">
          <div></div>
          <div>kcal</div>
          <div>%</div>
        </div>
        {SORTED_MEALS.map((meal) => (
          <div key={meal} className="mealOfDayRow">
            <div>{t(`mealOfDay.${meal}` as any)}</div>
            <div>{nutriNeeds.mealsKcalNeed[meal] || 0}</div>
            <div>{getDailyEnergyPercentage(meal)}</div>
          </div>
        ))}
      </div>
    </div>
  )
}
